import { usePremiereBuildIdentifier } from '@frameio/integrations/premiere/hooks/usePremiereBuildIdentifier';
import { MenuNonInteractiveArea } from '@frameio/vapor';

export function BuildIdentifierNavItem() {
  const premiereBuildIdentifier = usePremiereBuildIdentifier();

  return (
    <MenuNonInteractiveArea>{premiereBuildIdentifier}</MenuNonInteractiveArea>
  );
}
